module.exports = "select {\n    padding: 10px;\n    background-color: #f2dede;\n    margin: 10px 0;\n}"